import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

/**
 * Label/value rows for a drawer. `Fact` renders nothing for an empty value, so a
 * panel can list every field a record *might* carry without the caller guarding
 * each one — and without leaving a column of dashes behind.
 */
export function Fact({
  label,
  value,
  mono,
}: {
  label: string;
  value: ReactNode;
  mono?: boolean;
}) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className="flex items-baseline justify-between gap-3 py-1.5">
      <dt className="shrink-0 text-xs text-muted-foreground">{label}</dt>
      <dd className={cn('min-w-0 text-right text-sm break-all', mono && 'font-mono text-xs')}>
        {value}
      </dd>
    </div>
  );
}

export function FactSection({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <div>
      <h3 className="pb-1.5 text-sm font-semibold break-all">{title}</h3>
      <dl className="divide-y divide-line-soft border-t border-line-soft">{children}</dl>
    </div>
  );
}
